export default __webpack_public_path__ + "images/localizar-cliente-ico.svg";